module.exports = __webpack_public_path__ + "static/media/close_with_Background.61d01cf8.svg";